import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { setMobile } from "../../../redux/slices/authSlice";
import { sendOtp, OTP_TYPE } from "./services/authServices";
import { showNotification } from "../../../redux/slices/notificationSlice";
import InputField from "../../../components/InputField";
import AuthCard from "../../../components/AuthCard";
import Button from "../../../components/Button";
import RequiredLabel from "../../../components/RequiredLabel";

export default function AddMobileNumber() {
  // Raw digits only; allow leading 0 while typing
  const [mobileInput, setMobileInput] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const rawMobile = (mobileInput || "").replace(/\D/g, "");
  const normalizedMobile = rawMobile.replace(/^0+/, "");
  const isPhoneValid = normalizedMobile.length === 9 && /^4\d{8}$/.test(normalizedMobile);
  const requiredReason = t("pleaseCompleteRequiredFields");
  const handleNext = async () => {
    if (isSubmitting) return;
    const raw = (mobileInput || "").replace(/\D/g, "");
    const normalized = raw.replace(/^0+/, "");
    if (!raw) return;
    if (normalized.length !== 9 || !/^4\d{8}$/.test(normalized)) {
      dispatch(showNotification({ message: t('invalidPhone'), type: "error" }));
      return;
    }
    try {
      setIsSubmitting(true);
      await sendOtp(`+61${normalized}`, OTP_TYPE.PHONE);
      dispatch(setMobile(normalized));
      dispatch(
        showNotification({
          message: t('otpSentToMobile'),
          type: "success",
        })
      );
      navigate("/auth/verify-mobile-number");
    } catch (err) {
      dispatch(
        showNotification({ message: t('sendOtpFail'), type: "error" })
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-50 animate-fade-in">
      <AuthCard>
        <h2 className="sub-header mb-4">{t('mobileNumber')}</h2>
        <RequiredLabel htmlFor="add-mobile" className="mb-2">
          {t("mobileNumber")}
        </RequiredLabel>
        <InputField
          id="add-mobile"
          type="tel"
          value={(mobileInput || "").replace(/(\d{3})(?=\d)/g, "$1 ")}
          onChange={(e) => {
            const digits = e.target.value.replace(/\D/g, "");
            let v = digits;
            if (v.length > 9) {
              if (v.startsWith("0")) v = v.slice(1);
              v = v.slice(0, 9);
            }
            setMobileInput(v);
          }}
          placeholder={t('enterMobile')}
          required
        />
        <Button
          onClick={handleNext}
          className="w-full mt-4"
          disabled={!isPhoneValid || isSubmitting}
          disabledReason={!isPhoneValid ? requiredReason : ""}
          loading={isSubmitting}
          loadingLabel={t("loading")}
        >
          {t('next')}
        </Button>
      </AuthCard>
    </div>
  );
}
